export enum Pages {
  DATA_COLLECTOR = "datacollector",
  DATA_WRITER = "datapusher",
  JOB_RUNNER = "jobrunner",
  DATASETS_PAGE = "datasets",
}

const createApiConfig = () => {
  let _baseUrl: string | null = null;
  const params = new URLSearchParams(window.location.search);

  let uri: string | undefined;

  if (params.has("serviceId")) {
    uri = process.env.REACT_APP_BACKEND_BASE_URL;
  } else if (params.has("backend")) {
    uri = params.get("backend") ?? undefined;
  }

  if (uri && uri.endsWith("/")) {
    uri = uri.slice(0, -1);
  }

  const setBaseUrl = (page: Pages) => {
    if (!uri) {
      _baseUrl = null;
      return;
    }
    _baseUrl = `${uri}/${page}`;
  };

  const getBaseUrl = () => {
    if (!_baseUrl) {
      throw new Error("Base URL is not set. Call setBaseUrl() first.");
    }
    return _baseUrl;
  };

  return { setBaseUrl, getBaseUrl };
};

const ApiConfig = createApiConfig();
export { ApiConfig };
